import L from "leaflet";

// CARTO's legacy raster basemaps (basemaps.cartocdn.com) now REQUIRE an API key — keyless requests
// come back watermarked "API KEY REQUIRED". If a key is provided via REACT_APP_CARTO_KEY we keep
// CARTO's exact Dark/Light Matter look; otherwise we fall back to Esri's keyless Dark/Light Gray
// canvas so the map always renders cleanly with no key or account needed.
const CARTO_KEY = process.env.REACT_APP_CARTO_KEY;

export function addBasemap(map, { dark = true } = {}) {
  if (CARTO_KEY) {
    const style = dark ? "dark_all" : "light_all";
    return L.tileLayer(
      `https://{s}.basemaps.cartocdn.com/rastertiles/${style}/{z}/{x}/{y}{r}.png?key=${CARTO_KEY}`,
      { subdomains: "abcd", maxZoom: 20, attribution: "&copy; OpenStreetMap &copy; CARTO" },
    ).addTo(map);
  }
  const service = dark ? "World_Dark_Gray_Base" : "World_Light_Gray_Base";
  return L.tileLayer(
    `https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/${service}/MapServer/tile/{z}/{y}/{x}`,
    { maxNativeZoom: 16, maxZoom: 20, attribution: "Tiles &copy; Esri" },
  ).addTo(map);
}

